<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <div class="">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100%" class="demo-ruleForm">
              <el-form-item label="아이디" prop="mb_id">
                <el-input :disabled="mb_no ? true : false" placeholder="아이디를 입력해주세요." v-model="ruleForm.mb_id"></el-input>
              </el-form-item>
              <el-form-item label="이름" prop="mb_name">
                <el-input type="text" v-model="ruleForm.mb_name" placeholder="이름을 입력해주세요.">
                </el-input>
              </el-form-item>
              <el-form-item label="휴대폰번호" prop="mb_hp">
                <el-input v-model="ruleForm.mb_hp" type="number" placeholder="휴대폰번호를 입력해주세요."></el-input>
              </el-form-item>
              <el-form-item label="새 비밀번호" prop="mb_password">
                <el-input type="password" v-model="ruleForm.mb_password" placeholder="새 비밀번호을 입력해주세요.">
                </el-input>
              </el-form-item>
              <el-form-item label="새 비밀번호 확인" prop="mb_password_chk">
                <el-input type="password" v-model="ruleForm.mb_password_chk" placeholder="새 비밀번호 확인을 입력해주세요.">
                </el-input>
              </el-form-item>
              <el-form-item label="메모" prop="mb_memo">
                <el-input type="textarea" v-model="ruleForm.mb_memo" :rows="5" resize="none" placeholder="메모를 입력해주세요.">
                </el-input>
              </el-form-item>
              <el-form-item class="text-center">
                <el-button type="primary" @click="submitForm('ruleForm')">{{ mb_no ? '수정' : '등록' }}</el-button>
                <el-button @click="resetForm('ruleForm')">목록</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuxAlert from '@/mixins/vux-alert';
import sessionStorage from '@/mixins/sessionStorage';
import util from '@/mixins/util';
import axios from 'axios'
import validator from "@/mixins/validator";
import { countryList } from "@/service/countryService";


export default {
  name: "AdminCreate",
  components: {},
  mixins: [VuxAlert, axios, validator, sessionStorage],
  data() {
    return {
      userInfo: this.getUserInfo(),
      mb_no: this.$route.params.mb_no,
      ruleForm: {
        c_idx: 1,
        mb_id: '',
        mb_name: '',
        mb_hp: '',
        mb_password: '',
        mb_password_chk: '',
        mb_memo: '',
        mb_c_code: '',
      },
      rules: {
        mb_id: [
          { required: true, message: '필수 입력사항입니다.', trigger: 'blur' },
          { validator: this.validateEmail, trigger: 'blur' }
          // { min: 1, max: 16, message: '16이내로 입력해주세요', trigger: 'blur' }
        ],
        mb_name: [
          { required: true, message: '필수 입력사항입니다.', trigger: 'blur' }
        ],
        mb_hp: [
          { required: true, message: '필수 입력사항입니다.', trigger: 'blur' },
          { validator: this.validateNumber, trigger: 'blur' }
        ],
        mb_password_chk: [
          { validator: this.validatePass2, trigger: 'blur' }
        ]
      },
      file: [],
      file_required: false,
      defaultInfo: {},
      tabIndex: 1,
      tableList: [],
      category: [],
    };
  },
  created() {
  },
  mounted() {
    this.getCountryList();
    this.getDetail();
  },

  methods: {
    initData() {
      this.ruleForm = {
        mb_id: '',
        mb_name: '',
        mb_hp: '',
        mb_password: '',
        mb_password_chk: '',
        mb_memo: '',
        c_idx: 1,
        mb_c_code: '',
      };
      this.mb_no = this.$route.params.mb_no;
    },
    getCountryList() {
      this.$api.$user.getCountry()
        .then(res => { // 로그인 api 통신 후 결과 처리
          //let resultData = res.Data.result;
          // this.category = [{c_idx : 1 , CO_NAME_KOR : 'South Korea'},{c_idx : 2 , CO_NAME_KOR : 'Japan'}];
          this.category = countryList;
        });
    },
    getDetail() {
      if (this.mb_no) {
        this.initData();
        const params = { no: this.mb_no, m_type: 'admin' }
        this.$api.$user.getMemberList(params).then(res => res.Data.Result).then(res => {
          if (res.Info.Type === 1) {
            this.defaultInfo = res.List[0].Member;
            this.ruleForm = {
              mb_id: this.defaultInfo.mb_id,
              mb_name: this.defaultInfo.mb_name,
              mb_hp: this.defaultInfo.mb_hp,
              mb_memo: this.defaultInfo.mb_memo,
              c_idx: this.defaultInfo.c_idx,
              mb_c_code: this.defaultInfo.mb_c_code,
            }

          }
        })
      }
    },
    async submitForm(formName) {
      await this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            m_type: 'admin',
            mb_no: this.mb_no,
            mb_name: this.ruleForm.mb_name,
            mb_hp: this.ruleForm.mb_hp,
            mb_memo: this.ruleForm.mb_memo,
            c_idx: this.ruleForm.c_idx,
            mb_c_code: this.ruleForm.mb_c_code,
          }
          if (this.mb_password != '') {
            params.mb_password = this.ruleForm.mb_password
          }
          if (this.mb_no) {
            this.$api.$user.updateMember(params).then(res => res.Data.Result).then(res => {
              if (res.Info.Type === 1) {
                this.updateAlert({ getDetail: this.getDetail });
              } else {
                this.errorAlert(res.Info.reason);
              }
            })
          } else {
            params.mb_id = this.ruleForm.mb_id;
            this.$api.$user.createMember(params).then(res => res.Data.Result).then(res => {
              if (res.Info.Type === 1) {
                let alertParams = { 'element': this };
                this.saveAlert(alertParams);
              } else {
                this.errorAlert(res.Info.reason);
              }
            })
          }
        } else {
          this.validateAlert();
          return false;
        }
      });
    },

    resetForm(formName) {
      window.history.back();
    }
  }
}
</script>
